import { TableCell, Typography } from "@material-ui/core"

const BoldTableCell = ({ children, ...props }) => (
    <TableCell {...props}>
        <Typography><b>{children}</b></Typography>
    </TableCell>
)

export default BoldTableCell